import { Link } from "react-router-dom";
import { t } from "ttag";

import { MODAL_ROUTES, ROUTES, useNavigateModal } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { Button, CircleIcon, StethoscopeIcon } from "@/shared/ui";
import { DocumentCard } from ".";

export const DocumentCenterPrescriptions = () => {
  const navigateModal = useNavigateModal();

  const hasActiveSubscription = usePortalUserStore(
    (state) => state.hasActiveSubscription,
  );

  return (
    <DocumentCard.Root>
      <DocumentCard.Banner className="bg-secondary-100">
        <CircleIcon icon={StethoscopeIcon} size="lg" />
      </DocumentCard.Banner>

      <DocumentCard.Content>
        <DocumentCard.Title>{t`Previous Prescriptions`}</DocumentCard.Title>
        <DocumentCard.Description>{t`Upload your past prescriptions for your provider to access.`}</DocumentCard.Description>
      </DocumentCard.Content>

      <DocumentCard.Actions>
        <Button asChild variant="secondary" size="lg">
          <Link
            to={ROUTES.DOCUMENT_CENTER.PRESCRIPTIONS}
          >{t`View details`}</Link>
        </Button>

        {hasActiveSubscription && (
          <Button
            onClick={() =>
              navigateModal(MODAL_ROUTES.DOCUMENT_CENTER.PRESCRIPTIONS)
            }
            size="lg"
          >
            {t`Upload prescription`}
          </Button>
        )}
      </DocumentCard.Actions>
    </DocumentCard.Root>
  );
};
